export const DIALOG_TEXT = {
  close: '닫기',
  cancel: '취소',
  confirm: '확인',
  danger: '삭제하기',
} as const;
